<template>
<div class="map-container">
  <div ref="map" class="map-el"></div>
  <div class="sizer"></div>
  <div ref="marker" class="marker">
    <span /><i />
  </div>
</div>
</template>

<style src="mapbox-gl/dist/mapbox-gl.css"></style>

<script>
import mapboxgl from 'mapbox-gl'
import MultiTouch from 'mapbox-gl-multitouch'

mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_TOKEN

const avg = arr => {
  const min = Math.min(...arr)
  const max = Math.max(...arr)

  return min + ((max - min) / 2)
}

export default {
  props: {
    locations: Array,
    selected: [String, Number]
  },
  watch: {
    selected() {
      this.updateMarkers()
    }
  },
  async mounted() {
    const isMobile = window.matchMedia('(max-width: 640px)').matches

    const position = [
      avg(this.locations.map(({ coords }) => coords[0])) + 0.006,
      avg(this.locations.map(({ coords }) => coords[1]))
    ]

    const map = new mapboxgl.Map({
      container: this.$refs.map,
      style: 'mapbox://styles/mapbox/light-v9',
      center: position,
      zoom: isMobile ? 11 : 12
    })

    map.addControl(new MultiTouch())

    map.scrollZoom.disable()

    for(const location of this.locations) {
      const $marker = this.$refs.marker.cloneNode(true)
      $marker.style.display = 'block'
      $marker.setAttribute('data-num', location.num)

      const $label = $marker.querySelector('span')

      $label.innerText = `Site ${location.num}`

      $marker.addEventListener('click', event => {
        event.preventDefault()
        event.stopPropagation()

        this.$emit('select', location.num)
      })

      const marker = new mapboxgl.Marker({ element: $marker })
        .setLngLat(location.coords)
        .addTo(map)
    }

    this.updateMarkers()
  },
  methods: {
    updateMarkers() {
      const $markers = this.$el.querySelectorAll('.marker')
      Array.from($markers).forEach($marker => {
        $marker.classList.remove('active')

        let num = $marker.getAttribute('data-num')
        if(num) {
          if(this.selected === parseInt(num)) {
            $marker.classList.add('active')
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.marker {
  display: none;
  cursor: pointer;
  span {
    position: absolute;
    white-space: nowrap;
    line-height: 1;
    top: 50%;
    left: 100%;
    transform: translate(0, -37.5%);
    font-family: 'Trivia Serif';
    font-size: 1.4rem;
    color: black;
    margin-left: 0.5em;
  }
  i {
    width: 1em;
    height: 1em;
    border-radius: 50%;
    background: currentColor;
    display: block;
  }
  &.active, &:hover {
    color: var(--bg);
  }
}
.map-container {
  position: relative;
  width: 100%;
  height: 100%;
}
/deep/ .mapboxgl-ctrl-bottom-right {
  display: none !important;
}
.map-el {
  position: absolute;
  margin: var(--gutter);
  top: 0; left: 0;
  bottom: 0; right: 0;

  @media (max-width: 640px) {
    margin: 0;
  }
}
</style>
